import React from "react";
import "./TxnLookup.css";

function PayoutsModels({ modalData, setOpenModal }) {
  // console.log("model::::::::",modalData)
  return (
    <div className="modal-overlay">
      <div className="modal">
        <h3>{"Payment Details"}</h3>
        <div className="dialog-data">
          <p>
            <span>Beneficiary Name -</span>
            {modalData &&
              modalData.request.beneName
               || JSON.parse(modalData.request)?.beneName }
          </p>
          <p>
            <span>Amount -</span>₹
            {modalData && modalData.requestData && modalData.requestData.amount}
          </p>
          <p>
            <span>Beneficiary Mobile - </span>
            {modalData &&
              modalData.requestData &&
              modalData.requestData.beneMobile
            || JSON.parse(modalData.request)?.beneMobile
              }
          </p>
          <p>
            <span>Upi Address - </span>{" "}
            {modalData &&
              modalData.upiAddress &&
                modalData.requestData.upiAddress || JSON.parse(modalData.request)?.upiAddress}
          </p>
          <p>
            <span>Beneficiary Email - </span>
            {modalData &&
              modalData.beneEmail &&
                modalData.requestData.beneEmail || JSON.parse(modalData.request)?.beneEmail}
          </p>
          <p>
            <span>Beneficiary Bank Name - </span>{" "}
            {modalData &&
              modalData.requestData &&
              modalData.requestData.beneBankName
              || JSON.parse(modalData.request)?.beneBankName}
          </p>
          <p>
            <span>Ifsc Code -</span>{" "}
            {modalData &&
              modalData.requestData &&
              modalData.requestData.ifscCode
               || JSON.parse(modalData.request)?.ifscCode}
          </p>
          <p>
            <span>Account Number - </span>{" "}
            {modalData &&
              modalData.requestData &&
              modalData.requestData.accountNo
               || JSON.parse(modalData.request)?.accountNo}
          </p>
          <p>
            <span>Payment Mode -</span>{" "}
            {modalData && modalData.requestData && modalData.requestData.mode
             || JSON.parse(modalData.request)?.mode}
          </p>
          <p>
            <span>Order Id -</span>{" "}
            {modalData && modalData.orderId && modalData.orderId}
          </p>
          <p>
            <span>Transaction Id -</span>{" "}
            {modalData && modalData.transactionId && modalData.transactionId}
          </p>
          <p>
            <span>Ref Id -</span>{" "}
            {modalData && modalData.referenceId && modalData.referenceId}
          </p>
          <p>
              <span>UTR- </span>
              {modalData?.responseData?.UTR ?? 'N/A'}
            </p>
          <p>
            <span>RESPONSE MESSAGE- </span>
            {modalData &&
              modalData.responseData &&
              modalData.responseData.RESPONSE_MESSAGE &&
              modalData.responseData.RESPONSE_MESSAGE}
          </p>
        </div>

        <div className="modal-button">
          <button className="view-btn-1" onClick={() => setOpenModal(false)}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default PayoutsModels;
